import { useTheme } from '@chakra-ui/react'
import { getColor } from '@chakra-ui/theme-tools'
import { SVGProps, memo } from 'react'
import ErrorOctagonSvg from 'src/components/icons/ErrorOctagon.svg'

const ErrorOctagon = memo<SVGProps<SVGSVGElement>>(({ color = '#B5B5B5', ...rest }) => {
  const theme = useTheme()
  const resolvedColor = getColor(theme, color as string)
  return <ErrorOctagonSvg color={resolvedColor} {...rest} />
})

export default ErrorOctagon
